export const EQUIPMENT_SET_CREATE_REQUESTED = 'EQUIPMENT_SET_CREATE_REQUESTED';
export const EQUIPMENT_SET_CREATE_SUCCEEDED = 'EQUIPMENT_SET_CREATE_SUCCEEDED';
export const EQUIPMENT_SET_CREATE_FAILED = 'EQUIPMENT_SET_CREATE_FAILED';

export const EQUIPMENT_SET_UPDATE_REQUESTED = 'EQUIPMENT_SET_UPDATE_REQUESTED';
export const EQUIPMENT_SET_UPDATE_SUCCEEDED = 'EQUIPMENT_SET_UPDATE_SUCCEEDED';
export const EQUIPMENT_SET_UPDATE_FAILED = 'EQUIPMENT_SET_UPDATE_FAILED';

export const EQUIPMENT_SET_DELETE_REQUESTED = 'EQUIPMENT_SET_DELETE_REQUESTED';
export const EQUIPMENT_SET_DELETE_SUCCEEDED = 'EQUIPMENT_SET_DELETE_SUCCEEDED';
export const EQUIPMENT_SET_DELETE_FAILED = 'EQUIPMENT_SET_DELETE_FAILED';

export const EQUIPMENT_SET_SET = 'EQUIPMENT_SET_SET';
export const EQUIPMENT_SETS_SET = 'EQUIPMENT_SETS_SET';

export enum NozzleType {
    WEED_BOOM = 'WEED_BOOM',
    HV = 'HV',
    LV = 'LV'
}
